<template>
  <v-container>
    <v-alert type="success" :value="success" transition="slide-x-transition">
      Objednávka bola úspešne zrušená
    </v-alert>
    <v-row justify="center">
      <h2>
        <span class="pa-1">Prebiehajúce objednávky</span>
      </h2>
    </v-row>
    <v-divider />
    <v-container v-if="!noOrders">
      <v-container v-for="order in orders" :key="order.code">
        <v-card elevation="10" :id="'' + order.id">
          <v-row justify="center"
            ><v-col cols="12"
              ><cleaner-order :order="order"></cleaner-order></v-col
          ></v-row>
          <v-row v-if="order.date > getCurrentDate()" class="justify-center">
            <v-col class="text-center" cols="12">
              <v-btn color="error" @click="wantDelete(order.id)">
                Zrušiť objednávku
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-spacer></v-spacer>
      </v-container>
    <v-dialog
      max-width="290"
      v-model="dialog"
    >
      <v-card>
        <v-card-text class="headline">
          Naozaj chceš zrušiť objednávku?
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error darken-1"
            text
            @click="dialog = false; toDelete = null"
          >
            Nie
          </v-btn>
          <v-btn
            color="green darken-2"
            text
            @click="disapproveOrder()"
          >
            Áno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
    <v-container v-else>
      <span class="pa-1">Zatiaľ nemáte žiadne prebiehajúce objednávky</span>
    </v-container>
    <v-row class="mt-16" justify="center">
      <h2>
        <span class="pa-1">Ukončené objednávky</span>
      </h2>
    </v-row>
    <v-divider />
    <v-container v-if="!noFinishedOrders">
    <v-container v-for="order in finishedOrders" :key="order.code">
           <v-card elevation="10" :id="''+order.id">
                <v-row justify="center"><v-col cols="12"><cleaner-order  :order="order"></cleaner-order></v-col></v-row>          
            </v-card>
        <v-spacer></v-spacer>
    </v-container>
    </v-container>
    <v-container v-else>
      <span class="pa-1">Zatiaľ nemáte žiadne ukončené objednávky</span>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import store from "../store/store";
import CleanerOrder from "./orders/CleanerOrder.vue";
export default {
  components: { CleanerOrder },
  name: "CleanerOrders",
  data: () => ({
    dialog: false,
    toDelete: null,
    success: false,
    loading: false,
    userId: 1,
    show: false,
    current: "",
    noOrders: false,
    noFinishedOrders:false,
    orders: [
      /*
                {
                    "id" : 1,
                    "code" : "hs85hj",
                    "date" : "20.09.2020",
                    "building": "Šturák",
                    "block" : "VBA",
                    "flat" : "1023",
                    "cleaningType" : "izba + kúpelňa",
                    "term": "13:00",
                    "timeTo": "14:00",
                    "state" : "Nová",
                    "note" : "pouzit ekologicke cistiace prostriedky "
                },
                {
                    "id" : 1,
                    "code" : "hsg85hj",
                    "date" : "20.09.2020",
                    "building": "Šturák",
                    "block" : "VBA",
                    "flat" : "1023",
                    "cleaningType" : "izba + kúpelňa",
                    "term": "13:00",
                    "timeTo": "14:00",
                    "state" : "Nová"
                }*/
    ],
    finishedOrders: []
  }),
  methods: {
    fetchAllData() {
      axios
        .get(store.state.url.concat("getApprovedOrders.php"), {
          params: {
            user: localStorage.getItem("loggedUserId"),
          },
        })
        .then((response) => {
          if (response.data.result) {
            if (response.data.result == "noOrders") {
              this.noOrders = true;
              this.$emit("noOrders");
            }
          } else {
            this.noOrders = false;
            this.orders = response.data
            //this.fineshedOrders = response.date --> iba ukoncene
            /*response.data.forEach((element) => {
              this.findOrder(element.code);
            });*/
            this.$emit("orders");
          }
        });
      axios.get(store.state.url.concat("getFinishedOrders.php"), {
                params: {
                  user: localStorage.getItem("loggedUserId"),
                },
              })
              .then((response) => {
                if (response.data.result) {
                  if (response.data.result == "noOrders") {
                    this.noFinishedOrders = true;
                    this.$emit("noFinishedOrders");
                  }
                } else {
                  this.noFinishedOrders = false;
                  this.finishedOrders = response.data
                  //this.fineshedOrders = response.date --> iba ukoncene
                  /*response.data.forEach((element) => {
                    this.findOrder(element.code);
                  });*/
                  this.$emit("finishedOrders");
                }
              });
    },
    getEuroDate(date) {
      var myDate = new Date(date);
      return (
        ("0" + myDate.getDate()).slice(-2) +
        "." +
        ("0" + (myDate.getMonth() + 1)).slice(-2) +
        "." +
        myDate.getFullYear()
      );
    },
    getCurrentDate() {
      var myDate = new Date();
      return (
        myDate.getFullYear() +
        "-" +
        ("0" + (myDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + myDate.getDate()).slice(-2)
      );
    },
    alertOrderCanceled() {
      this.success = true;
      setTimeout(() => {
        this.success = false;
      }, 2500);
    },
    disapproveOrder() {
      let orderId = this.toDelete;
      this.dialog = false;
      this.error = "";
      const params = new URLSearchParams();
      params.append("user", localStorage.getItem("loggedUserId"));
      params.append("orderId", orderId);
      axios({
        method: "post",
        url: store.state.url.concat("disapproveOrder.php"),
        data: params,
      }).then((response) => {
        if (response.data.result == "ok") {
          this.alertOrderCanceled();
          document.getElementById("" + orderId).remove();
          this.$router.push({ name: "userDashboard" }).catch(() => {});
        } else {
          this.error = response.data.error;
        }
      });
    },
    findOrder(codeOfOrder) {
      const params = new URLSearchParams();
      params.append("orderCode", codeOfOrder);
      axios({
        method: "post",
        url: store.state.url.concat("findOrderByCode.php"),
        data: params,
      }).then((response) => {
        if (response.data.result == "ok") {
          if(response.data.state === "ukončená"){
              this.finishedOrders.unshift(response.data);
          }else{
              this.orders.unshift(response.data);
          }
        }
      });
    },
    wantDelete(id){
        this.toDelete = id;
        this.dialog = true;
    }
  },
  created() {
    this.fetchAllData();
  },
};
</script>

<style>
.no-border {
  border: none !important;
}
</style>